<template>
  <div class="complaint">
    <div class="box w-1200">
      <div class="card-body">
        <div class="tabs-box">
          <div class="left-title hit-cursor">
            <div v-for="item in terbars" :key="item.value" :class="[
              'ter-bar-item',
              activeName === item.value ? 'active' : '',
            ]" @click="handleTarBar(item.value)">
              {{ item.label }}
            </div>
          </div>
          <gradient-button width="160px" @hit="showDing" background="#0C60E6">发布投诉建议</gradient-button>
        </div>
        <div class="content-box">
          <div class="box-inner" v-loading="loading">
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
              :header-cell-style="{ fontWeight: 700, color: '#333' }">
              <el-table-column type="index" width="50" label="编号"></el-table-column>
              <el-table-column prop="content" label="反馈描述">
              </el-table-column>
              <el-table-column prop="type_text" label="类型"> </el-table-column>
              <el-table-column prop="created_at" label="提交时间">
              </el-table-column>
              <el-table-column prop="chuli_at" label="处理时间">
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status == 1">待处理</el-tag>
                  <el-tag v-else type="success">已处理</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDetail(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" background
                layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    弹窗-->
    <add-complaint :dialogFormVisible="dialogFormVisible" @close="dialogFormVisible = false" @success="successFun" />
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="投诉建议详情"
      :visible.sync="detailVisible">
      <div class="detail-box">
        <div>
          <el-row class="detail-item">
            <el-col :span="12">
              <span class="detail-label">投诉类型：</span>
              <span class="detail-value">{{ detail.type_text }}</span>
            </el-col>
            <el-col :span="12">
              <span class="detail-label">投诉时间：</span>
              <span class="detail-value">{{ detail.created_at }}</span>
            </el-col>
          </el-row>

          <el-row class="detail-item">
            <span class="detail-label">反馈描述：</span>
            <span class="detail-value">{{ detail.content }}</span>
          </el-row>
          <el-row class="detail-item">
            <span class="detail-label">反馈图片：</span>
            <span class="detail-value">
              <img v-for="(item, index) in detail.images" :key="index" :src="item" @click="handlePreview(item)"
                alt="反馈图片" />
            </span>
          </el-row>
          <el-row class="detail-item">
            <el-col :span="12">
              <span class="detail-label">处理状态：</span>
              <span class="detail-value">{{
                detail.status == 1 ? "待处理" : "已处理"
              }}</span>
            </el-col>

            <el-col :span="12">
              <span class="detail-label">处理时间：</span>
              <span class="detail-value">{{ detail.chuli_at || "--" }}</span>
            </el-col>
          </el-row>
          <el-row class="detail-item">
            <span class="detail-label">处理结果：</span>
            <span class="detail-value">{{ detail.result || "--" }}</span>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" title="图片预览" :modal="false"
      :visible.sync="previewVisible" width="60%" center :before-close="closePreview">
      <div class="preview-container">
        <img :src="previewImageUrl" alt="预览图片" class="preview-image" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import addComplaint from "@/components/addInfo/add_complaint.vue";
import GradientButton from "@/components/button/gradient-button.vue";
import { feedback, feedbackList, feedbackDetail } from "@/api/modules/user.js";
import ImageUpload from "@/components/public/ImageUpload.vue";
export default {
  name: "complaint",

  components: { GradientButton, ImageUpload, addComplaint },
  data() {
    return {
      previewVisible: false,
      previewImageUrl: "",
      activeName: 0,
      dialogFormVisible: false,
      tableData: [],
      imageUrl: "",

      terbars: [
        { label: "全部", value: 0 },
        { label: "待处理", value: 1 },
        { label: "已处理", value: 2 },
      ],

      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      detail: {},
      detailVisible: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 关闭预览
    closePreview() {
      this.previewVisible = false;
    },
    // 预览图片
    handlePreview(item) {
      this.previewImageUrl = item;
      this.previewVisible = true;
    },
    // 查看
    handleDetail(row) {
      feedbackDetail(row.id).then((res) => {
        if (res.data.code == 10000) {
          this.detail = res.data.data;
          this.detailVisible = true;
        }
      });
    },

    getList() {
      this.loading = true;
      feedbackList({
        page: this.page,
        limit: this.pageSize,
        status: this.activeName,
      })
        .then((res) => {
          if (res.data.code == 10000) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
            this.loading = false;
          } else {
            this.$message.error(res.data.message);
            this.loading = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    successFun() {
      this.dialogFormVisible = false;
      this.getList();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    // 切换处理状态
    handleTarBar(val) {
      this.activeName = val;
      this.page = 1;
      this.getList();
    },
    showDing() {
        this.dialogFormVisible = true;

    },
  },
};
</script>
<style scoped lang="scss">
.preview-container {
  text-align: center;
  margin-bottom: 20px;

  .preview-image {
    max-width: 100%;
    max-height: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.tabs-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 20px;

  .left-title {
    line-height: 28px;
    display: flex;
    align-items: center;
    gap: 50px;

    .ter-bar-item {
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
      border-bottom: 4px solid transparent;
    }

    .active {
      font-weight: bold;
      font-size: 18px;
      color: #00112b;
      border-bottom: 4px solid #1890ff;
    }
  }
}

/*去掉tabs底部的下划线*/
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.detail-box {
  background: pink;
  font-size: 18px;
  color: #333;

  .detail-item {
    padding: 20px;
    background: #fff;

    img {
      width: 100px;
      height: 100px;
      margin-right: 20px;
      vertical-align: middle;
    }

    .detail-value {
      // font-weight: bold;
    }
  }
}

/*去掉tabs底部的下划线*/
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

//投诉弹窗
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.pagination {
  text-align: right;
  // padding-top: 40px;
  padding: 20px 0;
}

.from-box {

  .avatar-uploader {
    width: 121px;
    height: 121px;
    border: 1px solid #e5e5e5;
    text-align: center;
    line-height: 121px;
  }

  .desc {
    font-weight: 400;
    font-size: 16px;
    color: #d8d8d8;
  }
}

.box {
  .card-head {
    padding: 30px 40px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }
  }

  .card-body {
    .box-inner {
      padding: 40px 80px 0;
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>
